<div class="base">
  <pp-common-components></pp-common-components>

  <div class="dashboard">
    @if (dashlets) {
      <gridster
        class="dashboard__content"
        [class.dashboard__content--full-width]="!sidePanel.expandedInitially"
        [options]="gridsterOptions"
      >
        @for (dashlet of dashlets; track dashletTrackByPosition($index, dashlet)) {
          <gridster-item [item]="dashlet" [ngClass]="dashlet.name" class="dashboard__gridster-item">
            @if (workspacesFetched) {
              <pp-dashlet
                [ppDashlet]="dashlet"
                (ppUpdateUserDashlets)="updateUserDashlets()"
                [ppCanEdit]="true"
              ></pp-dashlet>
            }
          </gridster-item>
        }
      </gridster>
    }
  </div>
</div>
